import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

/*
 * 1. TODO (see sherlock; might not be needed).
 * 2. Unclutter the map when store details are open, by hiding map controls.
 * 3. Scroll the map so the whole store details component is in view.
 * 4. Buttons and links within the store details should have their default behavior, and not hideDetails.
 */

registerComponent(
  "store-location",
  class StoreLocation extends WYATTElement {
    constructor() {
      super();

      this.active = false;
      this.markerTemplate = this.querySelector("[data-marker-template]");
      this.distanceElement = this.querySelector("[data-distance]");
      this.onGoogleMapReady = this.addMarker.bind(this);
    }

    connectedCallback() {
      this.subscribe(WYATT.PubSub.events.googleMapReady, this.onGoogleMapReady);

      this.distanceElement.textContent = `${(this.distance / 1000).toFixed(1)} km`;
    }

    get distance() {
      return WYATT.Geolocation.getDistanceBetween(
        this.config.location,
        WYATT.Geolocation.location.coordinates,
      );
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      if (this.marker) {
        this.marker.map = null;
      }
    }

    async addMarker() {
      const { AdvancedMarkerElement } =
        await google.maps.importLibrary("marker");

      this.marker = new AdvancedMarkerElement({
        map: WYATT.storeLocator.googleMap,
        position: this.config.location,
        title: this.config.name,
        content: this.buildMarker(),
        gmpClickable: true,
      });

      WYATT.storeLocator.googleMapBounds.extend(this.config.location);
      WYATT.storeLocator.googleMap.fitBounds(
        WYATT.storeLocator.googleMapBounds,
      );

      this.marker.addEventListener(
        "gmp-click",
        this.handleMarkerClick.bind(this),
      );
      WYATT.storeLocator.googleMap.addListener(
        "click",
        this.hideDetails.bind(this),
      );

      const closeButton = this.marker.content.querySelector("[data-close]");
      if (closeButton) {
        closeButton.addEventListener("click", (event) => {
          event.stopPropagation();
          this.hideDetails();
        });
      }
    }

    buildMarker() {
      const content =
        this.markerTemplate.content.firstElementChild?.cloneNode(true);

      return content;
    }

    handleMarkerClick() {
      if (this.active) {
        this.hideDetails();
      } else {
        this.showDetails();
      }
    }

    hideDetails() {
      this.active = false;
      this.dataset.active = false;
      this.marker.dataset.active = false;
      this.marker.zIndex = null;

      WYATT.storeLocator.googleMap.setOptions({
        disableDefaultUI: false,
      }); /* [2] */
    }

    showDetails() {
      const details = this.marker.content.querySelector("[data-details]");

      this.active = true;
      this.dataset.active = true;
      this.marker.dataset.active = true;
      this.marker.zIndex = 9999;

      this.scrollIntoView({ behavior: "smooth", block: "center" });

      WYATT.storeLocator.googleMap.setCenter({
        lat: this.marker.position.lat,
        lng: this.marker.position.lng,
      });
      WYATT.storeLocator.googleMap.panBy(
        0,
        (details.scrollHeight / 2) * -1,
      ); /* [3] */

      WYATT.storeLocator.googleMap.setOptions({
        disableDefaultUI: true,
      }); /* [2] */
    }
  },
);
